import { createRouter, createWebHistory } from 'vue-router'

// ALL views imported eagerly — no lazy loading, no chunk failures
import DashboardView from '@/views/DashboardView.vue'
import BlocksView from '@/views/BlocksView.vue'
import BlockDetailsView from '@/views/BlockDetailsView.vue'
import TransactionsView from '@/views/TransactionsView.vue'
import TransactionDetailsView from '@/views/TransactionDetailsView.vue'
import AccountsView from '@/views/AccountsView.vue'
import AccountDetailsView from '@/views/AccountDetailsView.vue'
import ValidatorsView from '@/views/ValidatorsView.vue'
import ValidatorDetailsView from '@/views/ValidatorDetailsView.vue'
import DeveloperView from '@/views/DeveloperView.vue'
import DeveloperTokensView from '@/views/DeveloperTokensView.vue'
import DeveloperIDEView from '@/views/DeveloperIDEView.vue'
import DexView from '@/views/DexView.vue'
import QuarnXSwapView from '@/views/QuarnXSwapView.vue'
import ContractsView from '@/views/ContractsView.vue'
import GovernanceView from '@/views/GovernanceView.vue'
import TokenSaleView from '@/views/TokenSaleView.vue'
import SearchResultsView from '@/views/SearchResultsView.vue'
import NotFoundView from '@/views/NotFoundView.vue'

const routes = [
  { path: '/', name: 'dashboard', component: DashboardView, meta: { title: 'Dashboard - QuarnX Explorer' } },
  { path: '/blocks', name: 'blocks', component: BlocksView, meta: { title: 'Blocos - QuarnX Explorer' } },
  { path: '/blocks/:id', name: 'block-details', component: BlockDetailsView, props: true, meta: { title: 'Detalhes do Bloco - QuarnX Explorer' } },
  { path: '/transactions', name: 'transactions', component: TransactionsView, meta: { title: 'Transações - QuarnX Explorer' } },
  { path: '/transactions/:hash', name: 'transaction-details', component: TransactionDetailsView, props: true, meta: { title: 'Detalhes da Transação - QuarnX Explorer' } },
  { path: '/accounts', name: 'accounts', component: AccountsView, meta: { title: 'Contas - QuarnX Explorer' } },
  { path: '/accounts/:address', name: 'account-details', component: AccountDetailsView, props: true, meta: { title: 'Detalhes da Conta - QuarnX Explorer' } },
  { path: '/validators', name: 'validators', component: ValidatorsView, meta: { title: 'Validadores - QuarnX Explorer' } },
  { path: '/validators/:id', name: 'validator-details', component: ValidatorDetailsView, props: true, meta: { title: 'Detalhes do Validador - QuarnX Explorer' } },
  { path: '/developer', name: 'developer', component: DeveloperView, meta: { title: 'Área do Desenvolvedor - QuarnX Explorer' } },
  { path: '/developer/tokens', name: 'developer-tokens', component: DeveloperTokensView, meta: { title: 'Meus Tokens - QuarnX Explorer', requiresWallet: true } },
  { path: '/developer/ide', name: 'developer-ide', component: DeveloperIDEView, meta: { title: 'Queen IDE - QuarnX Explorer', requiresWallet: true } },
  { path: '/dex', name: 'dex', component: DexView, meta: { title: 'DEX - QuarnX Explorer' } },
  { path: '/contracts', name: 'contracts', component: ContractsView, meta: { title: 'Contratos - QuarnX Explorer' } },
  { path: '/governance', name: 'governance', component: GovernanceView, meta: { title: 'Governança - QuarnX Explorer' } },
  { path: '/token-sale', name: 'token-sale', component: TokenSaleView, meta: { title: 'Comprar KinX - QuarnX Explorer' } },
  { path: '/quarnxswap', name: 'quarnxswap', component: QuarnXSwapView, meta: { title: 'QuarnXSwap - Exchange Cross-Chain' } },
  { path: '/search', name: 'search-results', component: SearchResultsView, props: route => ({ query: route.query.q }), meta: { title: 'Resultados da Busca - QuarnX Explorer' } },
  { path: '/:pathMatch(.*)*', name: 'not-found', component: NotFoundView, meta: { title: 'Página Não Encontrada - QuarnX Explorer' } }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { top: 0 }
  }
})

import { useWalletStore } from '@/stores/wallet'

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'QuarnX Explorer'
  
  // Proteger rotas que exigem carteira conectada
  if (to.meta.requiresWallet) {
    const wallet = useWalletStore()
    if (!wallet.hasWallet) {
      // Redirecionar pra página de desenvolvedor com aviso
      next({ name: 'developer', query: { auth: 'required' } })
      return
    }
  }
  
  next()
})

export default router
